




















import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import { EStatementStatuses } from '@zunta/configurations'

@Component({
  props: {
  },
  components: {
    Modal
  }
})
export default class BatchSuccessModal extends Vue {
  EStatementStatuses: any = EStatementStatuses;
  get batchID () {
    return this.$route.params.id
  }
}
